import { handleActions } from 'redux-actions';
import { setBackground, previewBackground } from './actions';
import { DeviationBackgroundState } from './types';
import { reduxKey } from './constants';

const actionHandlers = handleActions<DeviationBackgroundState, any>(
  {
    [setBackground.toString()]: (
      state,
      { payload: { deviationId, backgroundId } }: ReturnType<typeof setBackground>
    ) => ({
      ...state,
      [deviationId]: { backgroundId },
    }),
    [previewBackground.toString()]: (
      state,
      { payload: { backgroundId } }: ReturnType<typeof previewBackground>
    ) => ({
      ...state,
      backgroundPreview: backgroundId,
    }),
  },
  {}
);

export default {
  [reduxKey as string]: actionHandlers,
};
